module.exports = __webpack_public_path__ + "static/media/todeal2@2x.f5b1aa9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/todeal2@2x.png
// module id = 343
// module chunks = 0